import { CCol, CForm, CFormInput, CFormLabel } from '@coreui/react-pro'
import React, { useContext } from 'react'
import OrderAsyncDropdown from 'src/components/OrderAsyncDropdown'
import TableSearch from 'src/components/TableSearch'
import { ORDERS_LOG_SORT } from 'src/constants/SearchConstants'
import { LogContext } from 'src/context/LogContext'
import { getDefaultOrderLogColumns } from 'src/transformers/LogsTransformer'

const OrderLogsSearchForm = () => {
  const {
    onColumnManagerChange,
    handleSearchReset,
    handleSearchChange,
    searchParams,
    handleSearchSubmit,
    selectedOrderOption,
    handleClearOrder,
    t,
  } = useContext(LogContext)

  const onClear = () => {
    handleSearchReset()
  }

  return (
    <CForm onSubmit={handleSearchSubmit}>
      <TableSearch
        onColumnManagerChange={onColumnManagerChange}
        defaultColumns={getDefaultOrderLogColumns(t)}
        onClear={onClear}
        searchParams={searchParams}
        handleSearchChange={handleSearchChange}
        sortBy={ORDERS_LOG_SORT}
        t={t}
      >
        <CCol md={3} className="mb-3">
          <CFormLabel htmlFor="id">{t('id')}</CFormLabel>
          <CFormInput
            name="order_id"
            id="id"
            type="number"
            min={1}
            autoComplete="off"
            value={searchParams.order_id}
            onChange={handleSearchChange}
          />
        </CCol>
        <CCol md={3} className="mb-3">
          <OrderAsyncDropdown
            handleSearchChange={handleSearchChange}
            value={selectedOrderOption}
            isClearable={true}
            handleClearOrder={handleClearOrder}
          ></OrderAsyncDropdown>
        </CCol>
        <CCol xs="3">
          <CFormLabel htmlFor="action_like">{t('action_like')}</CFormLabel>
          <CFormInput
            type="text"
            id="action_like"
            name="action_like"
            value={searchParams.action_like}
            onChange={handleSearchChange}
            autoComplete="off"
          />
        </CCol>
      </TableSearch>
    </CForm>
  )
}

export default OrderLogsSearchForm
